import * as Sentry from '@sentry/react';
export default function errorWrapper(reducer) {
    return (...args) => {
        try {
            return reducer(...args);
        }
        catch (error) {
            if (window.RG_CONFIG.SENTRY_DSN) {
                Sentry.captureException(error);
            }
            console.error(error);
            throw error;
        }
    };
}
